<template>
  <div class="relative flex w-full max-w-[210px]" :class="isExpanded ? 'justify-start' : 'justify-center -ml-4'">
    <ContextMenuWrapper class="max-w-full" test-id="sidebar-user" @is-visible="(val: boolean) => (toggleUserMenu = val)">
      <a
        @click.prevent="false"
        href="#"
        data-testid="sidebar-usermenu-trigger"
        class="max-w-fit flex items-center gap-2 rounded-full focus-visible:ring focus-within:ring-blue-500/50 focus:outline-none"
      >
        <Avatar :avatar-url="avatar" :name="translateInitials(name)" />
        <span v-if="isExpanded" class="text-sm font-bold dark:text-zinc-500 truncate">{{ name }}</span>
        <button v-if="isExpanded" :class="toggleUserMenu ? 'rotate-180' : ''" class="block w-4 h-4 duration-300 ease-in-out rounded-full focus:outline-none">
          <Icon name="general.chevronDown" size="xs" />
        </button>
      </a>
      <template #menu>
        <template v-for="item in menuItems" :key="item.name">
          <MenuModal v-if="item?.action?.type === 'modal'" :icon="item.icon" :type="item.type" :component="item.action.params.component">
            {{ item.title }}
          </MenuModal>

          <MenuLink v-else-if="item?.href" :href="item.href" :icon="item.icon" :type="item.type">
            {{ item.title }}
          </MenuLink>

          <MenuSeparator v-else-if="item?.isSeparator" />

          <MenuRouterLink v-else-if="item.to" :to="{ name: item.to }" :icon="item.icon" :type="item.type">
            {{ item.title }}
          </MenuRouterLink>
        </template>
      </template>
    </ContextMenuWrapper>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { ContextMenuWrapper, Avatar, Icon, MenuLink, MenuRouterLink, MenuSeparator, MenuModal } from '@/storybook';

import { useNameInitials } from '@/composables/useNameInitials';
import { useUserMenu } from '@/composables/useUserMenu';

defineProps<{
  isExpanded: boolean;
  avatar?: string;
  name?: string;
}>();

const { translateInitials } = useNameInitials();
const { menuItems } = useUserMenu();

const toggleUserMenu = ref(false);
</script>
